import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4.93", x2: "19.07", y1: "4.93", y2: "19.07", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Ban";
const Ban = memo(themed(Icon));
export {
  Ban
};
//# sourceMappingURL=ban.js.map
